<template>
  <div class="container">
    <div>
      <ul>
        <li :key="index" @click="selected = index" :class="{'active-tab' : selected == index}" v-for="(tab, index) in tabs">
          {{ tab.name }}
        </li>
      </ul>
      <div :key="index" v-for="(tab, index) in tabs">
        <template v-if="index == selected">
          <p v-html="tab.content"></p>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tabs",
  props: ['tabs'],
  data() {
    return{
      selected: 0
    }
  },
}
</script>

<style scoped>
div {
  text-align: left;
}
.active-tab {
  border-bottom: 3px solid #0f202a;
}

ul {
  list-style: none;
  padding: 0;
  display: flex;
  gap: 10px;
}

ul li {
  white-space: nowrap;
  margin-right: 40px;
  font-size: 19px;
  font-weight: 500;
  color: #0f202a;
  line-height: 23px;
  padding-bottom: 3px;
  cursor: pointer;
}
</style>